/**
 * Single source of truth for the Android payment-return routes. Each appPath
 * must stay in lockstep with the android:pathPrefix intent-filter in the
 * Android app's manifest, and with the matching entry in
 * .stitchfix/fixops/values.prod*.yaml — see constants.test.ts, which checks
 * these against the ingress config.
 */
export const FIX_CHECKOUT_ORDER_RESUME_ROUTE = {
  appPath: '/android/fixcheckout/order/resume',
  webPath: '/fixcheckout/order/resume'
} as const;
export const MY_ITEMS_ORDERS_RESUME_ROUTE = {
  appPath: '/android/my-items/orders/resume',
  webPath: '/my-items/orders/resume'
} as const;

/**
 * Fix-scoped checkout's return. checkout-ui builds this return_url as /android
 * plus its own /fixcheckout/fixes/:fix_id/payment_callback, so the web fallback
 * keeps the fix id — that callback is fix-scoped and can't resume without it.
 */
export const fixCheckoutPaymentCallbackRoute = (fixId: string) => ({
  appPath: `/android/fixcheckout/fixes/${fixId}/payment_callback`,
  webPath: `/fixcheckout/fixes/${fixId}/payment_callback`
}) as const;

/**
 * The ingress entry for fixCheckoutPaymentCallbackRoute, any fix id. Must be a
 * trailing wildcard: the ingress doesn't match a "*" mid-path,
 * so those requests fall through to hellblazer's 404.
 * The trailing "*" also covers the trailing-slash variant.
 */
export const FIX_CHECKOUT_PAYMENT_CALLBACK_INGRESS_PATH = '/android/fixcheckout/fixes/*';

/**
 * Matches fixCheckoutPaymentCallbackRoute's appPath for any fix id. Deliberately
 * looser than the page accepts: a rejected id still renders a 404 at this URL,
 * client secret included, and that page must stay out of telemetry too.
 */
export const FIX_CHECKOUT_PAYMENT_CALLBACK_APP_PATH_PATTERN = /^\/android\/fixcheckout\/fixes\/.+\/payment_callback\/?$/;